<template>
<custom-popup
      v-model="showTuts"
      :cons="{title:'تنظیمات ارسال از فروشنده',icon:'truck-fast-outline'}"
      :loading.sync="isLoading"
      hide-confirm
      max-width="1240"
    >

  <v-card class="pa-4" flat>
    <v-progress-linear v-show="loading" class="mb-4" indeterminate />

    <v-form ref="form" v-model="valid" lazy-validation>
      <div class="pa-5 border rounded-xl" style="background: #f9f9f9">
        <v-row>
           <v-col cols="12" md="6">
          <v-text-field
            v-model.number="formData.sms_gap_time"
            :min="gapMinMax.min"
            :max="gapMinMax.max"
            :suffix="gapSuffix"
            clearable
            dense
            hide-spin-buttons
            label="فاصله زمانی از ارسال"
            outlined
            placeholder="فاصله زمانی از ثبت نام"
            type="number"
            class="gap-input-with-icon"
            @input="limitGapValue"
          >
            <template v-slot:append>
              <v-menu offset-y open-on-click close-on-content-click>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" class="ml-1">
                    <v-icon small>
                      {{ getGapIcon(formData.sms_gap_type) }}
                    </v-icon>
                  </v-btn>
                </template>

                <v-card max-width="300" class="pa-2">
                  <v-item-group v-model="formData.sms_gap_type" mandatory>
                    <div class="d-flex flex-wrap ga-2 flex-column">
                      <v-item
                        v-for="item in gapItems"
                        :key="item.value"
                        :value="item.value"
                        v-slot="{ active, toggle }"
                      >
                        <v-chip
                          :color="active ? 'primary' : 'grey lighten-3'"
                          :text-color="active ? 'white' : ''"
                          small
                          @click="toggle"
                          class="ma-1"
                        >
                          <v-icon small left>{{
                            getGapIcon(item.value)
                          }}</v-icon>
                          {{ item.text }}
                        </v-chip>
                      </v-item>
                    </div>
                  </v-item-group>
                </v-card>
              </v-menu>
            </template>
          </v-text-field>
          </v-col>
          
          <v-col cols="12">            
            <DigikalaSellerShippingSettings
              ref="sellerShippingRef" 
              :pattern-id.sync="formData.sms_pattern_id"
              :message-data.sync="formData.sms_message_data"
              :sms-type.sync="formData.sms_type"
            />       
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-switch 
              v-model="formData.status" 
              label="فعال کردن تنظیمات" 
              inset 
              dense
              class="mt-0"
              color="success"
            ></v-switch>
          </v-col>
        </v-row>

        <div class="d-flex flex-row justify-end mt-6">
          <v-btn
            class="btn-get-code rounded-lg px-8"
            @click.stop="saveSettings"
            :loading="saveLoading"
            :disabled="loading"
          >
            <v-icon left>mdi-content-save</v-icon>
            ذخیره تنظیمات
          </v-btn>
        </div>
      </div>
    </v-form>
  </v-card>
  </custom-popup>
</template>

<script>
import Timepicker from "@/view/components/Timepicker";
import CustomDatePicker from "../../../../src/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import DigikalaSellerShippingSettings from "./DigikalaSellerShippingSettings.vue";

export default {
  name: "SellerShippingSettings",
  props:{showTuts:{type:Boolean, default:false}},
  components: { Timepicker, CustomDatePicker, DigikalaSellerShippingSettings },
  data() {
    return {
      gapItems: [
        { value: "min", text: "دقیقه", min: 1, max: 60 },
        { value: "hour", text: "ساعت", min: 1, max: 24 },
        { value: "day", text: "روز", min: 1, max: 30 },
        { value: "week", text: "هفته", min: 1, max: 4 },
      ],
      valid: false,
      loading: false,
      saveLoading: false,
      formData: {
        status: false,
        type: "seller_shipping",
        seller_shipping_time: null,
        sms_date_time: null,
        sms_pattern_id: null,
        sms_message_data: {},
        sms_type: 'pattern',
        sms_gap_time: null, 
        sms_gap_type: "hour", 
      },
      rules: {
        required: value => (value !== null && value !== '' && value !== undefined) || 'این فیلد الزامی است.',
      }
    };
  },
  mounted() {
    this.fetchSettings();
  },
  computed:{
      gapMinMax() {
      return this.formData.sms_gap_type
        ? this.gapItems.find((item) => item.value === this.formData.sms_gap_type)
        : { min: 0, max: 24 };
    },
    gapSuffix() {
      return this.formData.sms_gap_type
        ? this.gapItems.find((item) => item.value === this.formData.sms_gap_type)?.text
        : "";
    },
  },
  methods: {
   limitGapValue() {
      if (!this.formData.sms_gap_type) return;
      if (this.formData.sms_gap_time > this.gapMinMax.max) {
        this.formData.sms_gap_time = this.gapMinMax.max;
      } else if (this.formData.sms_gap_time < this.gapMinMax.min) {
        this.formData.sms_gap_time = this.gapMinMax.min;
      }
    },
    getGapIcon(type) {
      const icons = {
        min: "mdi-clock-outline",
        hour: "mdi-clock-time-four-outline",
        day: "mdi-calendar-today",
        week: "mdi-calendar-week",
      };
      return icons[type] || "mdi-calendar-clock";
    },
    async fetchSettings() {
      this.loading = true;
      try {
        const res = await this.$api.get(`/v1/digikala/settings?type=${this.formData.type}`);
        if (res.data && (res.data.data || Object.keys(res.data).length > 0)) {
          const settings = res.data.data || res.data;

          Object.keys(this.formData).forEach(key => {
            if (key !== 'type' && settings[key] !== undefined) {
              this.formData[key] = settings[key];
            }
          });

          if (settings.message) {
            try {
              const parsedMessage = typeof settings.message === 'string' 
                ? JSON.parse(settings.message) 
                : settings.message;
              
              this.formData.sms_message_data = parsedMessage;

              if (parsedMessage.text && Array.isArray(parsedMessage.text)) {
                this.formData.sms_type = 'campaign';
              } else {
                this.formData.sms_type = 'pattern';
              }
            } catch (e) {
              console.error("Error parsing message JSON", e);
              this.formData.sms_message_data = {};
              this.formData.sms_type = 'pattern';
            }
          }
          
          if (this.formData.sms_pattern_id) {
            this.$nextTick(() => {
              if (this.$refs.sellerShippingRef) {
                this.$refs.sellerShippingRef.loadPatternData(this.formData.sms_pattern_id);
              }
            });
          }
        }
      } catch (error) {
        this.$toast.error("خطا در دریافت اطلاعات");
      } finally {
        this.loading = false;
      }
    },
    async saveSettings() {
      if (!this.$refs.form.validate()) {
        this.$toast.error("لطفاً خطاهای فرم را برطرف کنید.");
        return;
      }

      this.saveLoading = true;
      try {
        let formattedSellerTime = this.formData.seller_shipping_time;
        if (formattedSellerTime && formattedSellerTime.split(':').length > 2) {
          formattedSellerTime = formattedSellerTime.split(':').slice(0, 2).join(':');
        }

        const payload = {
          type: this.formData.type,
          status: this.formData.status,
          seller_shipping_time: formattedSellerTime, 
          sms_date_time: this.formData.sms_date_time,
          sms_pattern_id: this.formData.sms_pattern_id,
          message: JSON.stringify(this.formData.sms_message_data),
          sms_type: this.formData.sms_type, 
          sms_gap_time: this.formData.sms_gap_time,
          sms_gap_type: this.formData.sms_gap_type, 
        };

        await this.$api.post('/v1/digikala/settings/store', payload);
        this.$toast.success("تنظیمات با موفقیت ذخیره شد");
      } catch (error) {
        this.$toast.error("خطا در ذخیره تنظیمات");
      } finally {
        this.saveLoading = false;
      }
    }
  }
};
</script>
